import React, { useEffect, useMemo } from 'react';
import { Stack, useTheme } from '@mui/material';
import { resetDocument, useDocument, useInspectorDrawerOpen, useSamplesDrawerOpen } from '../documents/editor/EditorContext';
import { renderToStaticMarkup } from '../Packages/email-builder';
import { useGlobal } from '../Packages/GlobalContext';
import SMARTiFrameMessenger from '../Packages/SMARTiFrameMessenger';
import InspectorDrawer, { INSPECTOR_DRAWER_WIDTH } from './InspectorDrawer';
import SamplesDrawer, { SAMPLES_DRAWER_WIDTH } from './SamplesDrawer';
import TemplatePanel from './TemplatePanel';
function useDrawerTransition(cssProperty, open) {
    const { transitions } = useTheme();
    return transitions.create(cssProperty, {
        easing: !open ? transitions.easing.sharp : transitions.easing.easeOut,
        duration: !open ? transitions.duration.leavingScreen : transitions.duration.enteringScreen,
    });
}
export default function App() {
    const inspectorDrawerOpen = useInspectorDrawerOpen();
    const samplesDrawerOpen = useSamplesDrawerOpen();
    // Hook calls should be at the top level of the component, not inside functions
    const document = useDocument();
    const code = useMemo(() => renderToStaticMarkup(document, { rootBlockId: 'root' }), [document]);
    const marginLeftTransition = useDrawerTransition('margin-left', samplesDrawerOpen);
    const marginRightTransition = useDrawerTransition('margin-right', inspectorDrawerOpen);
    const smartMessenger = new SMARTiFrameMessenger();
    const { setGlobalState } = useGlobal();
    const updateGlobalContext = (globalKey, globalValue) => {
        setGlobalState((prev) => (Object.assign(Object.assign({}, prev), { [globalKey]: globalValue })));
    };
    smartMessenger.onMessage((data) => {
        switch (data['action']) {
            case 'loadTemplateData':
                console.log('Template - Load Request, data provided to load template', data);
                //Update all the Global Context Data
                updateGlobalContext('tags', data['data']['tags']);
                updateGlobalContext('shortcodes', data['data']['shortcodes']);
                updateGlobalContext('socials', data['data']['socials']);
                updateGlobalContext('logos', data['data']['logos']);
                updateGlobalContext('url', data['data']['url']);
                window.MyAppGlobals = {
                    tags: data['data']['tags'],
                    shortcodes: data['data']['shortcodes'],
                    siteURL: data['data']['url'],
                };
                resetDocument(data['data']['JSON']);
                break;
            case 'saveTemplate':
                console.log('Template - Save Request, return data to be saved ', data);
                returnSavedTemplate();
                break;
            case 'mediaLibrarySelected':
                console.log('Media Library - Selected Asset', data);
                break;
            case 'mediaLibraryNotSelected':
                console.warn('Media Library - No Selection', data);
                break;
            default:
                console.warn('Unknown Command: ' + data['action'], data);
                break;
        }
    }, 'https://app.getwebsmart.co.uk');
    function triggerLoadTemplate() {
        smartMessenger.sendMessage({ action: 'loadTemplate', data: '' });
    }
    // Now returnSavedTemplate can access the code correctly
    function returnSavedTemplate() {
        smartMessenger.sendMessage({
            action: 'saveTemplateData',
            data: {
                'JSON': document,
                'HTML': code
            }
        });
    }
    useEffect(() => {
        triggerLoadTemplate();
    }, []); // Make sure to include an empty dependency array to avoid triggering the effect on every render
    return (React.createElement(React.Fragment, null,
        React.createElement(InspectorDrawer, null),
        React.createElement(SamplesDrawer, null),
        React.createElement(Stack, { sx: {
                marginRight: inspectorDrawerOpen ? `${INSPECTOR_DRAWER_WIDTH}px` : 0,
                marginLeft: samplesDrawerOpen ? `${SAMPLES_DRAWER_WIDTH}px` : 0,
                transition: [marginLeftTransition, marginRightTransition].join(', '),
            } },
            React.createElement(TemplatePanel, null))));
}
//# sourceMappingURL=index.js.map